import { ITradeSlim } from '@shared/models';

export interface State {
  loading: boolean;
  data: ITradeSlim[];
  error: string;
}

export const initialState: State = {
  loading: false,
  data: [],
  error: null
};
